import Masthead from './masthead';

export default Masthead;